/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationFundBase,
  DonationFundBaseOptional,
  DonationFundBaseMetaI,
  DonationFundBaseTrackedI,
} from "./donation-fund-base";
import {
  DonationFundBaseTracked,
  DonationFundBaseMeta,
} from "./donation-fund-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DonationFundRef,
  DonationFundRefOptional,
  DonationFundRefMetaI,
  DonationFundRefTrackedI,
} from "./donation-fund-ref";
import {
  DonationFundRefTracked,
  DonationFundRefMeta,
} from "./donation-fund-ref";

/**
 *
 * @export
 * @interface DonationFundFull
 */
export interface DonationFundFullOptional extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof DonationFundFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationFundFull
   */
  assignId?: number;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundFull
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationFundFull
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundFull
   */
  showInCheckout?: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFundFull
   */
  portalDescription?: string;
  /**
   *
   * @type {string}
   * @memberof DonationFundFull
   */
  imageURL?: string;
  /**
   *
   * @type {string}
   * @memberof DonationFundFull
   */
  fundName?: string;
  /**
   *
   * @type {string}
   * @memberof DonationFundFull
   */
  letterText?: string;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundFull
   */
  isEndowment?: boolean;
}

export interface DonationFundFull
  extends
    DonationFundFullOptional,
    Deletable,
    DonationFundBase,
    DonationFundRef {
  /**
   *
   * @type {boolean}
   * @memberof DonationFundFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationFundFull
   */
  assignId: number;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundFull
   */
  active?: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationFundFull
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundFull
   */
  showInCheckout?: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFundFull
   */
  portalDescription?: string;
  /**
   *
   * @type {string}
   * @memberof DonationFundFull
   */
  imageURL?: string;
  /**
   *
   * @type {string}
   * @memberof DonationFundFull
   */
  fundName?: string;
  /**
   *
   * @type {string}
   * @memberof DonationFundFull
   */
  letterText?: string;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundFull
   */
  isEndowment?: boolean;
}

export interface DonationFundFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof DonationFundFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationFundFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundFull
   */
  active?: boolean;
  activeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DonationFundFull
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundFull
   */
  showInCheckout?: boolean;
  showInCheckoutIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFundFull
   */
  portalDescription?: string;
  portalDescriptionIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFundFull
   */
  imageURL?: string;
  imageURLIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFundFull
   */
  fundName?: string;
  fundNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DonationFundFull
   */
  letterText?: string;
  letterTextIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DonationFundFull
   */
  isEndowment?: boolean;
  isEndowmentIsSet: boolean;
}

transformDatesMap.set(
  "DonationFundFull",
  function (model: DonationFundFull) {},
);

export type DonationFundFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  active: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  showInCheckout: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  portalDescription: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  imageURL: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  fundName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  letterText: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  isEndowment: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var DonationFundFullMeta: DonationFundFullMetaI =
  {} as DonationFundFullMetaI;
DonationFundFullMeta = typeMeta("DonationFundFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  active: propertyMeta("active", false, false, false, MetaTypesBase.boolean),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  showInCheckout: propertyMeta(
    "showInCheckout",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  portalDescription: propertyMeta(
    "portalDescription",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  imageURL: propertyMeta("imageURL", false, false, false, MetaTypesBase.string),
  fundName: propertyMeta("fundName", false, false, false, MetaTypesBase.string),
  letterText: propertyMeta(
    "letterText",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  isEndowment: propertyMeta(
    "isEndowment",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = DonationFundFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([DonationFundRefMeta]);
  metaI.assignId.inheritedFrom = DonationFundRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([DonationFundBaseMeta]);
  metaI.active.inheritedFrom = DonationFundBaseMeta.active;
  metaI.displayOrder.inheritedFrom = DonationFundBaseMeta.displayOrder;
  metaI.showInCheckout.inheritedFrom = DonationFundBaseMeta.showInCheckout;
  metaI.portalDescription.inheritedFrom =
    DonationFundBaseMeta.portalDescription;
  metaI.imageURL.inheritedFrom = DonationFundBaseMeta.imageURL;
  metaI.fundName.inheritedFrom = DonationFundBaseMeta.fundName;
  metaI.letterText.inheritedFrom = DonationFundBaseMeta.letterText;
  metaI.isEndowment.inheritedFrom = DonationFundBaseMeta.isEndowment;
});

export class DonationFundFullTracked
  extends DeletableTracked
  implements DonationFundFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  active__I?: boolean = undefined;
  activeIsSet: boolean = false;
  set active(v: undefined | boolean) {
    if (v !== undefined) {
      this.active__I = v;
      this.activeIsSet = true;
    } else {
      this.active__I = v || undefined;
      this.activeIsSet = false;
    }
    this.changeTracker = true;
  }
  get active() {
    return this.active__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  showInCheckout__I?: boolean = undefined;
  showInCheckoutIsSet: boolean = false;
  set showInCheckout(v: undefined | boolean) {
    if (v !== undefined) {
      this.showInCheckout__I = v;
      this.showInCheckoutIsSet = true;
    } else {
      this.showInCheckout__I = v || undefined;
      this.showInCheckoutIsSet = false;
    }
    this.changeTracker = true;
  }
  get showInCheckout() {
    return this.showInCheckout__I;
  }
  portalDescription__I?: string = undefined;
  portalDescriptionIsSet: boolean = false;
  set portalDescription(v: undefined | string) {
    if (v !== undefined) {
      this.portalDescription__I = v;
      this.portalDescriptionIsSet = true;
    } else {
      this.portalDescription__I = v || undefined;
      this.portalDescriptionIsSet = false;
    }
    this.changeTracker = true;
  }
  get portalDescription() {
    return this.portalDescription__I;
  }
  imageURL__I?: string = undefined;
  imageURLIsSet: boolean = false;
  set imageURL(v: undefined | string) {
    if (v !== undefined) {
      this.imageURL__I = v;
      this.imageURLIsSet = true;
    } else {
      this.imageURL__I = v || undefined;
      this.imageURLIsSet = false;
    }
    this.changeTracker = true;
  }
  get imageURL() {
    return this.imageURL__I;
  }
  fundName__I?: string = undefined;
  fundNameIsSet: boolean = false;
  set fundName(v: undefined | string) {
    if (v !== undefined) {
      this.fundName__I = v;
      this.fundNameIsSet = true;
    } else {
      this.fundName__I = v || undefined;
      this.fundNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get fundName() {
    return this.fundName__I;
  }
  letterText__I?: string = undefined;
  letterTextIsSet: boolean = false;
  set letterText(v: undefined | string) {
    if (v !== undefined) {
      this.letterText__I = v;
      this.letterTextIsSet = true;
    } else {
      this.letterText__I = v || undefined;
      this.letterTextIsSet = false;
    }
    this.changeTracker = true;
  }
  get letterText() {
    return this.letterText__I;
  }
  isEndowment__I?: boolean = undefined;
  isEndowmentIsSet: boolean = false;
  set isEndowment(v: undefined | boolean) {
    if (v !== undefined) {
      this.isEndowment__I = v;
      this.isEndowmentIsSet = true;
    } else {
      this.isEndowment__I = v || undefined;
      this.isEndowmentIsSet = false;
    }
    this.changeTracker = true;
  }
  get isEndowment() {
    return this.isEndowment__I;
  }
  constructor(config?: DonationFundFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: DonationFundFullOptional,
    options?: AssignOptions,
  ): DonationFundFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.active && this.activeApplyFilter(optionsRequired.filter)) {
      this.active = config.active;
      if (optionsRequired.unassign) this.activeIsSet = false;
      else this.activeIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (
      config.showInCheckout &&
      this.showInCheckoutApplyFilter(optionsRequired.filter)
    ) {
      this.showInCheckout = config.showInCheckout;
      if (optionsRequired.unassign) this.showInCheckoutIsSet = false;
      else this.showInCheckoutIsSet = true;
    }
    if (
      config.portalDescription &&
      this.portalDescriptionApplyFilter(optionsRequired.filter)
    ) {
      this.portalDescription = config.portalDescription;
      if (optionsRequired.unassign) this.portalDescriptionIsSet = false;
      else this.portalDescriptionIsSet = true;
    }
    if (config.imageURL && this.imageURLApplyFilter(optionsRequired.filter)) {
      this.imageURL = config.imageURL;
      if (optionsRequired.unassign) this.imageURLIsSet = false;
      else this.imageURLIsSet = true;
    }
    if (config.fundName && this.fundNameApplyFilter(optionsRequired.filter)) {
      this.fundName = config.fundName;
      if (optionsRequired.unassign) this.fundNameIsSet = false;
      else this.fundNameIsSet = true;
    }
    if (
      config.letterText &&
      this.letterTextApplyFilter(optionsRequired.filter)
    ) {
      this.letterText = config.letterText;
      if (optionsRequired.unassign) this.letterTextIsSet = false;
      else this.letterTextIsSet = true;
    }
    if (
      config.isEndowment &&
      this.isEndowmentApplyFilter(optionsRequired.filter)
    ) {
      this.isEndowment = config.isEndowment;
      if (optionsRequired.unassign) this.isEndowmentIsSet = false;
      else this.isEndowmentIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DonationFundFullTrackedI {
    const cloned = {} as DonationFundFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.activeIsSetDeep() &&
      this.activeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.activeIsSet = true;
      cloned.active = this.active;
    } else {
      //cloned.activeIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.showInCheckoutIsSetDeep() &&
      this.showInCheckoutApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.showInCheckoutIsSet = true;
      cloned.showInCheckout = this.showInCheckout;
    } else {
      //cloned.showInCheckoutIsSet = false
    }
    if (
      this.portalDescriptionIsSetDeep() &&
      this.portalDescriptionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.portalDescriptionIsSet = true;
      cloned.portalDescription = this.portalDescription;
    } else {
      //cloned.portalDescriptionIsSet = false
    }
    if (
      this.imageURLIsSetDeep() &&
      this.imageURLApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.imageURLIsSet = true;
      cloned.imageURL = this.imageURL;
    } else {
      //cloned.imageURLIsSet = false
    }
    if (
      this.fundNameIsSetDeep() &&
      this.fundNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.fundNameIsSet = true;
      cloned.fundName = this.fundName;
    } else {
      //cloned.fundNameIsSet = false
    }
    if (
      this.letterTextIsSetDeep() &&
      this.letterTextApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.letterTextIsSet = true;
      cloned.letterText = this.letterText;
    } else {
      //cloned.letterTextIsSet = false
    }
    if (
      this.isEndowmentIsSetDeep() &&
      this.isEndowmentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isEndowmentIsSet = true;
      cloned.isEndowment = this.isEndowment;
    } else {
      //cloned.isEndowmentIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DonationFundFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.activeApplyFilter(filter)) this.activeIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.showInCheckoutApplyFilter(filter))
      this.showInCheckoutIsSet = false;

    if (!this.portalDescriptionApplyFilter(filter))
      this.portalDescriptionIsSet = false;

    if (!this.imageURLApplyFilter(filter)) this.imageURLIsSet = false;

    if (!this.fundNameApplyFilter(filter)) this.fundNameIsSet = false;

    if (!this.letterTextApplyFilter(filter)) this.letterTextIsSet = false;

    if (!this.isEndowmentApplyFilter(filter)) this.isEndowmentIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundFullMeta.isDeleted,
      DonationFundFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundFullMeta.isNew,
      DonationFundFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundFullMeta.assignId,
      DonationFundFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  activeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundFullMeta.active,
      DonationFundFullMeta,
      this.active,
      this,
    );
  }
  activeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.activeIsSet && this.activeApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundFullMeta.displayOrder,
      DonationFundFullMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  showInCheckoutApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundFullMeta.showInCheckout,
      DonationFundFullMeta,
      this.showInCheckout,
      this,
    );
  }
  showInCheckoutIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.showInCheckoutIsSet && this.showInCheckoutApplyFilter(filter))
      return true;

    return false;
  }
  portalDescriptionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundFullMeta.portalDescription,
      DonationFundFullMeta,
      this.portalDescription,
      this,
    );
  }
  portalDescriptionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.portalDescriptionIsSet &&
      this.portalDescriptionApplyFilter(filter)
    )
      return true;

    return false;
  }
  imageURLApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundFullMeta.imageURL,
      DonationFundFullMeta,
      this.imageURL,
      this,
    );
  }
  imageURLIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.imageURLIsSet && this.imageURLApplyFilter(filter)) return true;

    return false;
  }
  fundNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundFullMeta.fundName,
      DonationFundFullMeta,
      this.fundName,
      this,
    );
  }
  fundNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.fundNameIsSet && this.fundNameApplyFilter(filter)) return true;

    return false;
  }
  letterTextApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundFullMeta.letterText,
      DonationFundFullMeta,
      this.letterText,
      this,
    );
  }
  letterTextIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.letterTextIsSet && this.letterTextApplyFilter(filter)) return true;

    return false;
  }
  isEndowmentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationFundFullMeta.isEndowment,
      DonationFundFullMeta,
      this.isEndowment,
      this,
    );
  }
  isEndowmentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isEndowmentIsSet && this.isEndowmentApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.activeIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.showInCheckoutIsSetDeep(filter)) return true;
    if (this.portalDescriptionIsSetDeep(filter)) return true;
    if (this.imageURLIsSetDeep(filter)) return true;
    if (this.fundNameIsSetDeep(filter)) return true;
    if (this.letterTextIsSetDeep(filter)) return true;
    if (this.isEndowmentIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
